import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonCallsActionCreators from '../../../actionCreators/common';
import * as categoryCallsActionCreators from '../../../actionCreators/category';
import getSetCookie from '../../../cookie';
import Helmet from 'react-helmet';
import LKModal from '../Modal/Modal';
import Button from '../../../CommonComponents/BootstrapComponents/Button/Button';
import './DittoProfile.scss';
import BlankLoader from '../../components/Common/BlankLoader';
import CommonLoader from './Loader';

class DittoProfile extends PureComponent {
  constructor(props) {
    super(props);
    this.editName = this.editName.bind(this);
    this.cancelEditName = this.cancelEditName.bind(this);
    this.saveDittoName = this.saveDittoName.bind(this);
    this.setDefaultDitto = this.setDefaultDitto.bind(this);
    this.handleAlertShow = this.handleAlertShow.bind(this);
    this.handleAlertHide = this.handleAlertHide.bind(this);
    this.deleteDitto = this.deleteDitto.bind(this);
    this.state = {
      defaultDittoId: null,
      saveNameId: null,
      alertPopup: false,
      deleteDittoID: null,
      dittoCounts: null,
      showCreateDitto: false,
    };
  }

  componentDidMount() {
    const { commonCallsAction, dittoProfile, refreshDittoProfile } = this.props;
    if (!dittoProfile || refreshDittoProfile) {
      commonCallsAction.getDittoProfiles();
    }
    if (dittoProfile && dittoProfile.status !== 200) {
      this.showDittoCreate();
    }
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { saveDittoName, dittoProfile, commonCallsAction, deleteDittoProfile } = this.props;
    if (saveDittoName !== prevProps.saveDittoName && saveDittoName !== null) {
      commonCallsAction.getDittoProfiles();
    }
    if (saveDittoName !== prevProps.saveDittoName && prevProps.saveDittoName !== null) {
      this.saveNameId();
    }
    if (dittoProfile !== prevProps.dittoProfile && dittoProfile && dittoProfile.result) {
      this.setDefaultId(dittoProfile.result.defaultDittoId);
      this.resetDeleteState();
    }
    if (
      prevProps.deleteDittoProfile !== deleteDittoProfile &&
      deleteDittoProfile &&
      deleteDittoProfile.result &&
      this.state.defaultDittoId !== deleteDittoProfile.result.defaultDittoId
    ) {
      this.setDefaultId(deleteDittoProfile.result.defaultDittoId);
    }
    if (
      (!this.state.showCreateDitto && dittoProfile && dittoProfile.status !== 200) ||
      (deleteDittoProfile && deleteDittoProfile.status !== 200)
    ) {
      this.showDittoCreate();
    }
  }
  setDefaultDitto = dittoId => {
    const { commonCallsAction, showDittoChange, page } = this.props;
    this.setDefaultId(dittoId);
    commonCallsAction.setDitto(dittoId);
    if (page === 'product') {
      showDittoChange(false);
      commonCallsAction.updateDittoChangedState(true);
    }
  };
  setDefaultId = id => {
    getSetCookie.setCookie('isDittoID', id);
    this.setState({
      defaultDittoId: id,
    });
  };
  showDittoCreate = () => {
    this.setState({ showCreateDitto: true });
  };

  saveNameId = () => {
    this.setState({ saveNameId: null });
  };

  cancelEditName = () => {
    this.setState({ saveNameId: null });
  };

  saveDittoName = (dittoId, index) => {
    const dittoObj = {
      id: dittoId,
      nickname: this.refs[`saveName${index}`].value,
    };
    this.props.commonCallsAction.saveDittoName(dittoObj);
  };

  editName = dittoId => {
    this.setState({ saveNameId: dittoId });
  };

  handleAlertShow = (dittoId, length) => {
    this.setState({
      alertPopup: true,
      deleteDittoID: dittoId,
      dittoCounts: length,
    });
  };

  handleAlertHide = () => {
    this.setState({ alertPopup: false });
  };

  deleteDitto = () => {
    const { commonCallsAction } = this.props;
    const { deleteDittoID } = this.state;
    commonCallsAction.deleteDitto(deleteDittoID);
  };

  resetDeleteState = () => {
    const { commonCallsAction, categoryCallsAction } = this.props;
    const { deleteDittoID, dittoCounts } = this.state;
    if (this.refs[`dittoItem${deleteDittoID}`]) {
      this.refs[`dittoItem${deleteDittoID}`].classList.add('remove-ditto');
    }
    if (dittoCounts === 1) {
      getSetCookie.setCookie('isDittoID', '');
      getSetCookie.setCookie('dittoAccessID', '');
      getSetCookie.setCookie('dittoSignature', '');
      if (getSetCookie.getCookie('showMeDitto') === 'true') {
        getSetCookie.setCookie('showMeDitto', false);
        categoryCallsAction.updateDittoEnable(false);
      }
      commonCallsAction.getUserInfo();
      this.showDittoCreate();
    }
    this.setState({
      alertPopup: false,
      deleteDittoID: null,
      dittoCounts: null,
    });
  };

  createNewDitto = () => {
    localStorage.setItem('dittoCompare', window.location.href);
    window.location.href = '/compare-looks';
  };
  render() {
    const { dittoProfile, dittoProfileAuthImages, page, deleteDittoProccessing, dataLocale } =
      this.props;
    const {
      SET_DEFAULT,
      MANAGE_YOUR_DITTO,
      CREATE_NEW_DITTO,
      CREATED_ON,
      OR_SELECT_FROM_EXISTING_DITTO,
      DITTO_TRY_ON_HEADING,
      ALERT,
      YOU_WANT_TO_DELETE_DITTO,
      DELETE,
      CLOSE,
      MY_DITTO,
      HEY_SPECSY,
    } = dataLocale;
    const getDittoProfile = dittoProfile && dittoProfile.result;
    const renderDittoProfile =
      getDittoProfile &&
      getDittoProfile.dittoId &&
      getDittoProfile.dittoId.map((ditto, index) => {
        let created = new Date(ditto.created);
        created = created ? created.toDateString().slice(0, 15) : null;
        return (
          <div
            key={ditto.created + index}
            ref={`dittoItem${ditto.id}`}
            className="dittoProfiles_list_item"
          >
            {dittoProfileAuthImages && (
              <img
                alt={`${MY_DITTO}#${index + 1}`}
                src={dittoProfileAuthImages[index]}
                title={`${MY_DITTO}#${index + 1}`}
              />
            )}
            <h4>
              <i
                className="glyphicon glyphicon-edit dittoProfiles_list_item_editName"
                onClick={() => this.editName(ditto.id)}
              ></i>{' '}
              {ditto.nickname ? ditto.nickname : `${HEY_SPECSY}#${index + 1}`}
              {this.state.saveNameId === ditto.id && (
                <div className="dittoProfiles_list_item_saveNameBox">
                  <i
                    className="glyphicon glyphicon-remove dittoProfiles_list_item_cancelEditName"
                    onClick={() => this.cancelEditName()}
                  ></i>
                  <input
                    ref={`saveName${index}`}
                    className="dittoProfiles_list_item_saveNameBox_save"
                    defaultValue={ditto.nickname ? ditto.nickname : ''}
                    name={`saveName${index}`}
                    type="text"
                  />
                  <i
                    className="glyphicon glyphicon-ok-sign dittoProfiles_list_item_saveNameBox_ok"
                    onClick={() => this.saveDittoName(ditto.id, index)}
                  ></i>
                </div>
              )}
              <span className="dittoProfiles_list_item_created">{`${CREATED_ON} ${created}`}</span>
            </h4>
            <div className="dittoProfiles_list_item_nav">
              {getSetCookie.getCookie('isDittoID') !== ditto.id && (
                <span className="ditto-set" onClick={() => this.setDefaultDitto(ditto.id)}>
                  {SET_DEFAULT}
                </span>
              )}
              {page === 'myAccount' && (
                <span
                  className="ditto-del"
                  onClick={() => this.handleAlertShow(ditto.id, getDittoProfile.dittoId.length)}
                >
                  {DELETE}
                </span>
              )}
            </div>
            {getSetCookie.getCookie('isDittoID') === ditto.id && (
              <span className="dittoProfiles_list_item_defaultDitto">
                <img
                  alt="def-icon"
                  src="//static.lenskart.com/media/desktop/img/icon-default.png"
                />
              </span>
            )}
          </div>
        );
      });
    return (
      <div className="dittoProfiles">
        {deleteDittoProccessing && <CommonLoader />}
        {page === 'myAccount' && <Helmet title={MANAGE_YOUR_DITTO} />}
        {page === 'myAccount' && (
          <h2>
            {MANAGE_YOUR_DITTO}
            <button className="btn btn-warning pull-right" onClick={() => this.createNewDitto()}>
              {CREATE_NEW_DITTO}
            </button>
          </h2>
        )}
        {!this.state.showCreateDitto &&
          getDittoProfile && [
            <div key="ditto_profile_1" className="dittoProfiles_select">
              <span className="dittoProfiles_select_info">{OR_SELECT_FROM_EXISTING_DITTO}</span>
              <hr />
            </div>,
            <div key="ditto_profile_2" className="dittoProfiles_list">
              {dittoProfileAuthImages && getDittoProfile && renderDittoProfile}
            </div>,
          ]}
        {!this.state.showCreateDitto && !dittoProfileAuthImages && (
          <div className="dittoProfiles_list">
            <BlankLoader />
          </div>
        )}
        {((this.props.dittoProfile && this.props.dittoProfile.status !== 200) ||
          this.state.showCreateDitto) && (
          <div className="dittoProfiles_banner">
            <p>
              <a href="/compare-looks">
                {' '}
                <img
                  alt={DITTO_TRY_ON_HEADING}
                  src="https://static.lenskart.com/media/desktop/img/create-ditto-banner.jpg"
                  title={DITTO_TRY_ON_HEADING}
                />
              </a>
            </p>
          </div>
        )}
        <LKModal
          backdrop
          keyboard
          dialogClassName="dittoProfiles_deleteDlg"
          headerTitle={ALERT}
          hideHandler={() => this.handleAlertHide()}
          showModal={this.state.alertPopup}
          size="large"
        >
          <div className="delete-alert">{YOU_WANT_TO_DELETE_DITTO}</div>
          <div className="dittoProfiles_deleteDlg_footer">
            <Button variant="outlined" onClick={() => this.handleAlertHide()}>
              {CLOSE}
            </Button>
            <Button variant="danger" onClick={() => this.deleteDitto()}>
              {DELETE}
            </Button>
          </div>
        </LKModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dittoProfile: state.common.dittoProfile,
  refreshDittoProfile: state.common.refreshDittoProfile,
  saveDittoName: state.common.saveDittoName,
  dittoProfileAuthImages: state.common.dittoProfileAuthImages,
  deleteDittoProfile: state.common.deleteDittoProfile,
  deleteDittoProccessing: state.common.deleteDittoProccessing,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    categoryCallsAction: bindActionCreators(categoryCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DittoProfile);
